import { makeStyles } from '@material-ui/core/styles';
import { PrimaryColors } from '@/utils/constants';

const useNavigationButtonStyles = makeStyles(
  ({ palette, spacing, breakpoints }) => ({
    navigationButton: {
      cursor: 'pointer',
      color: palette.secondary.main,
      fontWeight: 'bold',
      fontSize: '15px',
      alignItems: 'center',
      lineHeight: '17px',
      userSelect: 'none',
      display: 'flex',
      padding: spacing(1, 0),
      background: 'none',
      boxShadow: 'none',
      border: 'none',

      [breakpoints.up('md')]: {
        display: 'inline-flex',
        background: PrimaryColors.light,
        borderRadius: '8px',
        padding: spacing(1, 2),
      },

      '& .button-content-wrapper': {
        position: 'relative',
      },
    },
    buttonLabel: {
      display: 'inline-block',
      margin: spacing(0, 1, 0, 0),
    },
  }),
  { name: 'NavigationButton' },
);

export default useNavigationButtonStyles;
